<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <base-card max-width="500">
      <v-card-text>
        <div class="d-flex flex-column align-center text-center py-6">
          <v-icon size="72" color="warning" class="mb-4">
            mdi-file-document-alert
          </v-icon>

          <h2 class="font-weight-bold mb-2">Código de formulario inválido</h2>

          <v-divider class="mb-6" />

          <p class="text--secondary mb-6">
            El formulario al que intentas acceder no existe, ha expirado o no
            está asociado a ninguna compañía.
          </p>

        </div>
      </v-card-text>
    </base-card>
  </v-container>
</template>

<script>
export default {
  name: "HabeasDataNotFound",
  methods: {
    //
  },
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
